var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "20153F28-5F74-4203-BD34-4E7DE1811029") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 90,
    height: 70.9937888
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.65485151,
    offset: "52.095853%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-111.000000, -922.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cover-Image",
    transform: "translate(111.000000, 922.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.279452, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_One-of-the-most-deadly-poisonous-plants-in-the-US-to-both-humans-and-animals,-Bulblet-Bearing-Water_47pzPb_free",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.279452055,-27 L89.7205479,-27 L89.7205479,63 C87.7281768,62.2488912 85.453288,61.679701 83.0681868,61.2697673 L83.0681868,56.9122633 C83.2675079,56.8368177 83.4500011,56.8292723 83.6426091,56.7395748 C84.017706,56.8745405 84.4054195,56.9876983 84.8057281,56.9876983 C86.7316575,56.9876983 88.3086705,55.4159066 88.3086705,53.4954716 C88.3086705,52.0175686 87.2918699,50.8515687 85.9395016,50.3560516 C85.9546398,50.24372 85.9849171,50.1154607 85.9849171,50.0031377 C85.9849171,48.082617 84.4080117,46.5259333 82.4819747,46.5259333 C80.5559376,46.5259333 78.9790322,48.096888 78.9790322,50.0175161 C78.9798732,50.1298476 79.0093078,50.2430204 79.0244478,50.3553434 C77.81674,50.798798 76.9900284,51.8290617 76.8025445,53.0840143 C76.6461156,52.9934778 76.5468749,52.8358908 76.3761415,52.7763601 C76.3837106,52.6791194 76.406417,52.5810375 76.406417,52.4837925 C76.406417,50.8667197 75.0851812,49.549747 73.4628258,49.549747 C71.8404704,49.549747 70.5192346,50.8675352 70.5192346,52.4837925 C70.5200756,52.5810332 70.534373,52.6791151 70.5495102,52.7763601 C69.4116029,53.1971742 68.5487208,54.1737873 68.5478811,55.4161856 C68.5478811,57.0332584 69.8842526,58.3502311 71.5065434,58.3502311 C71.84463,58.3502311 72.160024,58.2596945 72.4779155,58.1473652 C72.6385492,58.2228108 72.8126435,58.2228108 72.9783174,58.2898741 L72.9783174,60.4904082 C71.0961156,60.4904082 69.3601891,60.6781854 67.7529694,60.9187763 C67.1306211,59.2665087 66.376229,57.646088 65.4427928,56.1657599 L62.4992016,51.5007306 L49.9891542,31.6667376 C47.1902451,27.2397024 42.6764658,27.2397024 39.8775567,31.6667376 L35.8296882,38.0921513 L25.2773701,21.3681778 C22.478461,16.9411426 17.9797528,16.9411426 15.1808436,21.3681778 L-0.272794957,45.8672002 L-0.279452055,-27 Z M74.2158518,22 L74.2152711,22 C71.9612293,22.0017412 69.8000903,22.8983425 68.2073669,24.4924323 C66.6146435,26.0865072 65.7199537,28.2470507 65.7205479,30.5 C65.7199676,32.7528008 66.6147327,34.9139385 68.2073669,36.5075677 C69.8006849,38.1016427 71.9612293,38.9983655 74.2152711,39 C76.4710965,39.00058 78.6344653,38.1057281 80.2301615,36.5115789 C81.8251146,34.917504 82.7211422,32.7545835 82.7205479,30.5 C82.7211284,28.2454165 81.8252037,26.0832388 80.2301615,24.4890153 C78.6352085,22.8949404 76.4710965,21.999406 74.2152711,22 L74.2158518,22 Z M79.5367207,55 C80.1757709,55.4097765 80.9043481,55.7087514 81.7367153,55.7087514 C82.1919572,55.7087514 82.6424204,55.5909173 83.070063,55.4484737 C83.2862542,55.5276151 83.4976813,55.5355301 83.7205479,55.6296213 L83.7205479,60 C80.732901,59.5902235 77.6557758,59.4011496 74.7205479,59.4011496 L74.7205479,57.0928225 C74.9100712,57.0136811 75.1034027,57.0136811 75.287211,56.9433328 C75.645319,57.0611668 76.0053044,57.156136 76.3872083,57.156136 L76.4043513,57.156136 C77.882449,57.156136 79.1013768,56.2363395 79.5377966,55.0017199 L79.5367207,55 Z",
    id: "Shape",
    fill: "#979797",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    x: 0.720547945,
    y: 50.310559,
    width: 90,
    height: 20.6832298
  }), /*#__PURE__*/React.createElement("text", {
    id: "Title",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 61,
    fill: "#FFFFFF"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Lorem-ipsum-dolar-si",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 3.5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 66,
    fill: "#FFFFFF"
  }, "Lorem ipsum dolar sit amet")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/Cover.e8536273b5c499b44120fe0abce0d7d7.svg";
export { ForwardRef as ReactComponent };